export default "__VITE_ASSET__DecS0B0X__"